/* (c) Copyright Frontify Ltd., all rights reserved. */

export const defaultAttributes = {
    xmlns: 'http://www.w3.org/2000/svg',
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 0.1,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
};
